import { createReducer, on } from '@ngrx/store';
import {
  loadPortfolioList,
  loadPortfolioListSuccess,
  loadPortfolioListFailure,
  clearPortfolioList,
} from './portfolio.actions';

export interface PortfolioState {
  data: any[] | null;
  loading: boolean;
  error: any;
}

export const initialState: PortfolioState = {
  data: null,
  loading: false,
  error: null,
};

export const portfolioReducer = createReducer(
  initialState,
  on(loadPortfolioList, (state) => ({ ...state, loading: true, error: null })),
  on(loadPortfolioListSuccess, (state, { data }) => ({ ...state, loading: false, data })),
  on(loadPortfolioListFailure, (state, { error }) => ({ ...state, loading: false, error })),
  on(clearPortfolioList, (state) => ({ ...state, data: null }))
);
